import {
  GET_STUDY_MANAG,
  ADD_STUDY_MANAGMENT,
  UPDATE_STUDY_MANAGMENT,
  GET_STUDY_BY_ID,
  GET_STUDY_MANAG_LIST,
} from '../types'

const INITIAL_STATE = {
  getAllMang: [],
  addStudyMang: [],
  updateStudy: [],
  getOneStudy: [],
  getAllStudyManagList: [],
  page_count: null,
}

const studyManagReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_STUDY_MANAG:
      return {
        ...state,
        getAllMang: payload.data,
      }

    case GET_STUDY_MANAG_LIST:
      return {
        ...state,
        getAllStudyManagList: payload.data,
        page_count: payload.total_records,
      }

    case ADD_STUDY_MANAGMENT:
      return {
        ...state,
        addStudyMang: payload.data,
        loader: false,
      }

    case UPDATE_STUDY_MANAGMENT:
      return {
        ...state,
        updateStudy: payload.data,
      }
    case GET_STUDY_BY_ID:
      return {
        ...state,
        getOneStudy: payload.data,
      }
    default:
      return state
  }
}

export default studyManagReducer
